import React, { useState, useEffect } from "react";
import { handleGetRequest } from "../../../services/GetTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import "../../../components/DataTable.css";
import AddEditMenu from "./AddEditMenu";
import { useParams } from "react-router-dom";

/* eslint-disable */
function Menu() {
  const [menu, setMenu] = useState([]);
  const [loading, setloading] = useState([]);
  const [displayModal, setDisplayModal] = useState(false);
  const [setPosition] = useState("center");
  const [editable, setEditable] = useState(false);
  const [menuRowData, setMenuRowData] = useState({});
  const { moduleId } = useParams();
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const editHandler = (rowData) => {
    setDisplayModal(true);
    setMenuRowData(rowData);
    setEditable(true);
  };
  const getMenu = async () => {
    setloading(true);
    const response = await handleGetRequest(
      `zbizgateway/nonFin/getAllMenuByModuleId/${moduleId}`
    );
    setMenu(response?.data);
    setloading(false);
  };
  useEffect(() => {
    getMenu();
  }, []);

  const actionTemplate = (rowData) => {
    return (
      <div>
        <Button
          tooltip="Edit"
          icon="pi pi-pencil"
          tooltipOptions={{ position: "top" }}
          onClick={() => editHandler(rowData)}
          className="p-button-rounded p-button-secondary p-mr-2"
        />
      </div>
    );
  };

  const dialogFuncMap = {
    displayModal: setDisplayModal,
  };

  const onClick = (name, position) => {
    dialogFuncMap[`${name}`](true);

    if (position) {
      setPosition(position);
    }
  };

  const onHide = (name) => {
    setDisplayModal(false);
  };

  return (
    <div>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <i
              className="pi pi-arrow-circle-left mr-1"
              onClick={() => history.goBack()}
            />
            <h3 className="mod_heading">Menu</h3>
          </div>
          <Button
            label="Add New"
            className="Add_New"
            onClick={() => onClick("displayModal", setEditable(false))}
          />
        </div>
      </div>
      <Dialog
        header={editable ? "Edit Menu" : "Add Menu"}
        visible={displayModal}
        style={{ width: "50vw" }}
        onHide={() => onHide("displayModal")}
      >
        <AddEditMenu
          onHide={onHide}
          editable={editable}
          menuRowData={menuRowData}
          moduleId={moduleId}
          getMenu={getMenu}
        />
      </Dialog>

      <div className="card p-datatable-sm">
        <DataTable
          loading={loading}
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={rows}
          first={first}
          rowsPerPageOptions={[10, 20, 50, 100, 200]}
          onPage={handlePageChange}
          value={menu}
          emptyMessage="No data found."
        >
          <Column filter field="menuName" header="Menu Name" />
          <Column
            filter
            field={(i) => (i?.menuType === "F" ? "Form" : "Page")}
            header="Menu Type"
          />
          <Column filter field="menuPath" header="Menu Path" />
          <Column body={actionTemplate} header="Action" />
        </DataTable>
      </div>
    </div>
  );
}

export default Menu;
